import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React, { useContext } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { identity } from 'lodash-es';
import Button from '../Button';
import Skeleton from '../Skeleton';
import Typography from '../Typography';
import { TmsUIContext } from '../../TmsUIProvider';
import translations from './translations';
import { chunkNotificationList } from './utils';
import { BASE_LEFT_PADDING, NotificationBody, NotificationEmpty, NotificationHead, NotificationItem, NotificationItemContent, NotificationList, NotificationLoadMoreWrapper, NotificationSection, NotificationSectionTitle, NotificationWrapper } from './components';
var NotificationItemIndicator = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  min-width: ", ";\n  text-align: center;\n  font-size: 2rem;\n  line-height: 1.75rem;\n  opacity: ", ";\n  color: ", ";\n"])), BASE_LEFT_PADDING, function (props) {
  return props.show ? 1 : 0;
}, function (props) {
  return props.theme.colors.darkGrey;
});

var Notification = function Notification(_ref) {
  var _ref$notificationList = _ref.notificationList,
      notificationList = _ref$notificationList === void 0 ? [] : _ref$notificationList,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$hasNextPage = _ref.hasNextPage,
      hasNextPage = _ref$hasNextPage === void 0 ? false : _ref$hasNextPage,
      _ref$nextPageLoading = _ref.nextPageLoading,
      nextPageLoading = _ref$nextPageLoading === void 0 ? false : _ref$nextPageLoading,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? identity : _ref$onSelect,
      _ref$onReadAll = _ref.onReadAll,
      onReadAll = _ref$onReadAll === void 0 ? identity : _ref$onReadAll,
      _ref$onLoadMore = _ref.onLoadMore,
      onLoadMore = _ref$onLoadMore === void 0 ? identity : _ref$onLoadMore,
      _ref$formatter = _ref.formatter,
      formatter = _ref$formatter === void 0 ? identity : _ref$formatter;
  var chunkedNotificationList = chunkNotificationList(notificationList);

  var _useContext = useContext(TmsUIContext),
      setDefaultTranslations = _useContext.setDefaultTranslations,
      translate = _useContext.translate; // Intended to invoke this function without using useEffect hook


  setDefaultTranslations(translations);
  return /*#__PURE__*/React.createElement(NotificationWrapper, null, /*#__PURE__*/React.createElement(NotificationHead, null, /*#__PURE__*/React.createElement(Typography.Text, null, translate('common:notification')), notificationList.filter(function (notification) {
    return !notification.isRead;
  }).length > 0 && /*#__PURE__*/React.createElement(Button, {
    type: "link",
    onClick: onReadAll
  }, translate('common:mark_all_as_read'))), /*#__PURE__*/React.createElement(NotificationBody, null, loading ? /*#__PURE__*/React.createElement(NotificationEmpty, {
    useTabs: false
  }, /*#__PURE__*/React.createElement(Skeleton, {
    loading: loading,
    active: true,
    avatar: true
  }), /*#__PURE__*/React.createElement(Skeleton, {
    loading: loading,
    active: true,
    avatar: true
  }), /*#__PURE__*/React.createElement(Skeleton, {
    loading: loading,
    active: true,
    avatar: true
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(chunkedNotificationList).map(function (notificationDate) {
    return /*#__PURE__*/React.createElement(NotificationSection, {
      key: notificationDate
    }, /*#__PURE__*/React.createElement(NotificationSectionTitle, null, /*#__PURE__*/React.createElement(Typography.Text, {
      strong: true,
      type: "secondary"
    }, moment(notificationDate).format('DD MMMM YYYY'))), /*#__PURE__*/React.createElement(NotificationList, null, chunkedNotificationList[notificationDate].map(function (notification) {
      return /*#__PURE__*/React.createElement(NotificationItem, {
        key: notification.key,
        isRead: notification.isRead,
        role: "button",
        onFocus: function onFocus(e) {
          return e;
        },
        onKeyPress: function onKeyPress(event) {
          return ['Enter', 'Space'].includes(event.key) && onSelect(notification);
        },
        onClick: function onClick() {
          return onSelect(notification);
        },
        useTabs: false
      }, /*#__PURE__*/React.createElement(NotificationItemIndicator, {
        show: !notification.isRead
      }, "\u2022"), /*#__PURE__*/React.createElement(NotificationItemContent, {
        useTabs: false
      }, /*#__PURE__*/React.createElement(Typography.Text, null, formatter(notification.content, notification)), /*#__PURE__*/React.createElement(Typography.Text, {
        type: "secondary"
      }, "".concat(moment(notification.time).format('HH:mm'), " WIB"))));
    })));
  }), Object.keys(chunkedNotificationList).length < 1 && /*#__PURE__*/React.createElement(NotificationEmpty, {
    useTabs: false
  }, /*#__PURE__*/React.createElement(Typography.Text, {
    type: "secondary"
  }, translate('message:empty_notification'))), hasNextPage && /*#__PURE__*/React.createElement(NotificationLoadMoreWrapper, null, /*#__PURE__*/React.createElement(Button, {
    type: "link",
    block: true,
    loading: nextPageLoading,
    onClick: onLoadMore
  }, translate('common:load_more'))))));
};

export default Notification;